import { render, staticRenderFns } from "./Theme1Section2.vue?vue&type=template&id=06eb4ab8&scoped=true&"
import script from "./Theme1Section2.vue?vue&type=script&lang=js&"
export * from "./Theme1Section2.vue?vue&type=script&lang=js&"
import style0 from "./Theme1Section2.vue?vue&type=style&index=0&id=06eb4ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb4ab8",
  null
  
)

export default component.exports